import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    padding: ${theme.spacing(2)}px;
  `,
  title: css`
    margin: ${theme.spacing(0, -1)};
    padding: ${theme.spacing(0, 1)};
    font-size: 13px;
    font-weight: 500;
    line-height: 24px;
    color: ${theme.go.schemes.colors.system.TextMinor};
    border-radius: 6px;
    background-color: ${theme.go.schemes.colors.system.BgMinor};
  `,
  primary: css`
    font-size: 16px;
    line-height: 19px;
    color: ${theme.go.schemes.colors.system.TextMain};
  `,
  secondary: css`
    font-size: 13px;
    line-height: 15px;
    color: ${theme.go.schemes.colors.system.TextMinor};
  `,
  item: css`
    padding-top: ${theme.spacing(2)}px;
    padding-bottom: ${theme.spacing(2)}px;
    border-bottom: 1px solid transparent;

    &:not(:last-child) {
      border-bottom-color: #d2d0cc;
    }

    [dir='rtl'] & {
      text-align: right;
    }
  `,
}
